// ==========================
// src/components/Objectives.jsx
// ==========================
import React from 'react';
import { Grid, Card, CardContent, Typography, CardMedia } from '@mui/material';

import imgLiquidez from '../assets/images/liquidez.webp';
import imgCompra from '../assets/images/compra.webp';
import imgEmpleo from '../assets/images/empleo.webp';

const items = [
  {
    title: 'Soluciones de liquidez',
    img: imgLiquidez,
    text: 'Brindar soluciones efectivas a las necesidades de liquidez de nuestros clientes que cuenten con joyas y piezas de oro o plata, considerando la realidad económica nacional e internacional.'
  },
  {
    title: 'Compra ágil, oportuna y segura',
    img: imgCompra,
    text: 'Ofrecer un servicio de compra ágil, oportuno y seguro, cumpliendo estrictamente con las normativas establecidas por los entes de control.'
  },
  {
    title: 'Impulso al desarrollo y empleo',
    img: imgEmpleo,
    text: 'Impulsar el desarrollo económico mediante la generación de nuevas fuentes de empleo, fortaleciendo así el crecimiento de la empresa y la comunidad.'
  },
];

export default function Objectives(){
  return (
    <Grid container spacing={3}>
      {items.map((it) => (
        <Grid item xs={12} md={4} key={it.title} sx={{width:'100%'}}>
          <Card elevation={0} sx={{ border: '1px solid #eee', height: '100%', display:'flex', flexDirection:'column' }}>
            <CardMedia component="img" image={it.img} alt={it.title} sx={{ height: 180, objectFit:'cover' }} />
            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: 800 }}>{it.title}</Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>{it.text}</Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}